import React from 'react'
import { connect } from 'react-redux'
import { bool } from 'prop-types'
import SearchContentContainer from '../../../SearchContent/SearchContentContainer'

const SearchContent = ({ toggleStatus }) =>
  toggleStatus && <SearchContentContainer animationClass="slideInUp" />

SearchContent.propTypes = {
  toggleStatus: bool.isRequired,
}

const mapStateToProps = ({ ui }) => ({
  toggleStatus: ui.searchContentFooter,
})

export default connect(mapStateToProps)(SearchContent)



// WEBPACK FOOTER //
// ./src/components/Elements/Footer/PostSearch/SearchContent/index.jsx